var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseTable", {
    staticClass: "custom-table",
    attrs: { tableClass: "table-bordered", hidePagination: "" },
    scopedSlots: _vm._u([
      {
        key: "thead",
        fn: function() {
          return [
            _c("thead", [
              _c("tr", [
                _c("th", { staticStyle: { width: "190px" } }, [
                  _vm._v(_vm._s(_vm.$t("apps.billing.label.date")) + " UTC")
                ]),
                _vm._v(" "),
                _c("th", { staticStyle: { width: "150px" } }, [
                  _vm._v(_vm._s(_vm.$t("apps.billing.label.detail")))
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "text-center" }, [
                  _vm._v(
                    _vm._s(_vm.$t("apps.billing.label.quantity")) +
                      " (" +
                      _vm._s(_vm.$t("apps.billing.label.used")) +
                      ")"
                  )
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "text-center" }, [
                  _vm._v(
                    _vm._s(_vm.$t("apps.billing.label.duration")) +
                      " (" +
                      _vm._s(_vm.$t("apps.billing.label.unithours")) +
                      ")"
                  )
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.$t("apps.billing.label.unitprice")))
                ]),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass: "text-right",
                    staticStyle: { width: "140px" }
                  },
                  [_vm._v(_vm._s(_vm.$t("apps.billing.label.payamount")))]
                )
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "tbody",
        fn: function() {
          return [
            _c(
              "tbody",
              [
                _c("tr", [
                  !_vm.items.length
                    ? _c(
                        "td",
                        { staticClass: "text-center", attrs: { colspan: "6" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("message.notfounddata")) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._l(_vm.items, function(item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getDateTimeUTC(item.createdAt)) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("apps.billing.message.warehousecount")
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-center" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.numberel(item.countTotal)) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-center" }, [
                      _vm._v("\n          1\n        ")
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-center" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("apps.billing.message.unitpricewarehouse", {
                              number: item.amountPerUnit
                            })
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        "\n          " + _vm._s(item.amountTotal) + "\n        "
                      )
                    ])
                  ])
                })
              ],
              2
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4289f6a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4289f6a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseTableUsegeWarehouse.vue
// module id = null
// module chunks = 